import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({ id: 'feedback' });
export const viewFeedbackRouteRef = createRouteRef({ id: 'view-feedback' });